import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faArrowDown,
  faArrowUp,
  faEdit,
  faEllipsisH,
  faExternalLinkAlt,
  faEye,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Nav,
  Card,
  Image,
  Button,
  Table,
  Dropdown,
  ProgressBar,
  Pagination,
  ButtonGroup,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import { Routes } from "../routes";
import { pageVisits, pageTraffic, pageRanking } from "../data/tables";
import transactions from "../data/transactions";
import commands from "../data/commands";
import CanadaFlag from "../assets/img/flags/bulgaria.svg";
import BulFlag from "./bulgaria.png";

import db from "./firebase.config.js";
import { useParams } from "react-router-dom";
import moment from "moment";
import { Form, InputGroup } from "@themesberg/react-bootstrap";
import {
  faCheck,
  faCog,
  faHome,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

import ReactLoading from "react-loading";

export const RankingTable = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, useLoading] = useState(false);

  const SetLoading = () => {
    useLoading((prev) => !prev);
  };
  const fetchBlogs = async () => {
    const response = db.collection("players").orderBy("elo", "desc");
    const data = await response.get();
    data.docs.forEach((item) => {
      setBlogs((blogs) => [...blogs, item.data()]);
    });
    SetLoading();
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  let rank = 1;

  const PlayerRow = (props) => {
    return (
      <li className='rank-item'>
        <div className='rank-player'>
          <div className='rank-player_rank'>
            <div>
              <span> {rank++}</span>
            </div>
          </div>
          <div className='rank-player__name'>
            <div>
              <Link to={"/player/" + props.id}>
                <img
                  src={BulFlag}
                  alt='bul'
                  className='bornan-flag bornan-flag-sm'
                />
                <span className='org'>BUL</span>
                <span>
                  {props.name} {props.lastName}
                </span>
              </Link>
            </div>
            <div>
              <span className='text-orange'>{props.elo} Rating</span>
            </div>
          </div>
          <div className='rank-player__actions'>
            <div>
              <span className='hide-mobile m-r-5'>Профил</span>
              <i className='fa fa-user-circle text-grey'></i>
            </div>
            <div>
              <span className='hide-mobile m-r-5 '>Детайли</span>
              <i className='fa fa-bar-chart text-lgreen'></i>
            </div>
          </div>
        </div>
      </li>
    );
  };

  return (
    <>
      <div id='home'>
        <div className='home-list'>
          <div className='frame'>
            <div className='SubTitle'>
              <h6>Топ 10 - Висша Лига</h6>
              <p>Януари 2022</p>
            </div>

            {loading && blogs ? (
              <ul>
                {blogs
                  .filter((item) => item.elo >= 2000)
                  .slice(0, 10)
                  .map((r) => (
                    <PlayerRow key={`${r.id}`} {...r} />
                  ))}
              </ul>
            ) : (
              <div>
                <ReactLoading
                  type={"spin"}
                  className={"loading-home"}
                  color={"orange"}
                  height={50}
                  width={50}
                />
                <h5 className={"loading-text"}>Loading...</h5>
              </div>
            )}

            {loading ? (
              <div class='full-list-link'>
                <Link to='/ranking' class=''>
                  <i class='fa fa-users m-r-5 text-grey'></i>
                  <span class='text-gray'>Виж цялото класиране</span>
                </Link>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className='frame'>
            <div className='SubTitle'>
              <h6>Топ 10 - А група</h6>
              <p>Януари 2022</p>
            </div>

            {loading ? (
              <ul>
                {blogs
                  .filter((item) => item.elo <= 2000)
                  .slice(0, 10)
                  .map((r) => (
                    <PlayerRow key={`${r.id}`} {...r} />
                  ))}
              </ul>
            ) : (
              <div>
                <ReactLoading
                  type={"spin"}
                  className={"loading-home"}
                  color={"orange"}
                  height={50}
                  width={50}
                  name={"Loading..."}
                />
                <h5 className={"loading-text"}>Loading...</h5>
              </div>
            )}

            {loading ? (
              <div class='full-list-link'>
                <Link to='/ranking' class=''>
                  <i class='fa fa-users m-r-5 text-grey'></i>
                  <span class='text-gray'>Виж цялото класиране</span>
                </Link>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export const SearchTable = () => {
  const [blogs, setBlogs] = useState([]);
  const [AllPlayers, setAllPlayers] = useState([]);
  const fetchBlogs = async () => {
    const response = db.collection("players").orderBy("elo", "desc");
    const data = await response.get();
    data.docs.forEach((item) => {
      setBlogs((blogs) => [...blogs, item.data()]);
      setAllPlayers((AllPlayers) => [...AllPlayers, item.data()]);
    });

    SetLoading((state) => !state);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  let rank = 1;

  const PlayerRow = (props) => {
    return (
      <li className='rank-item'>
        <div className='rank-player'>
          <div className='rank-player_rank'>
            <div>
              <span> {activeItem * resultsPerPage + rank++}</span>
            </div>
          </div>
          <div className='rank-player__name'>
            <div>
              <Link to={"/player/" + props.id}>
                <img
                  src={BulFlag}
                  alt='bul'
                  className='bornan-flag bornan-flag-sm'
                />
                <span className='org'>BUL</span>
                <span>
                  {props.name} {props.lastName}
                </span>
              </Link>
            </div>
            <div>
              <span className='text-orange'>{props.elo} Rating</span>
            </div>
          </div>
          <div className='rank-player_action'></div>
          <div className='rank-player__actions'>
            <Link to={"/player/" + props.id}>
              <div>
                <span className='hide-mobile m-r-5'>Детайли</span>
                <i className='fa fa-user-circle text-gray'></i>
              </div>
              <div>
                <span className='hide-mobile m-r-5'>Прогрес</span>
                <i class='fa fa-bar-chart text-lgreen'></i>
              </div>
            </Link>
          </div>
        </div>
      </li>
    );
  };
  const [activeItem, setActiveItem] = React.useState(0);
  const resultsPerPage = 15;
  const totalPages = Math.ceil(AllPlayers.length / resultsPerPage);
  const [Loading, SetLoading] = useState(false);
  const [Afilter, setAfilter] = useState({
    leagueUpper: 2500,
    leagueLower: 1000,
    name: "",
    city: "",
  });
  let items = [];

  const handleCity = (event) => {
    setAfilter({ ...Afilter, city: event.target.value });
  };
  const handleName = (event) => {
    setAfilter({ ...Afilter, name: event.target.value });
  };
  const handleLeague = (event) => {
    setActiveItem(0);
    if (event.target.value == 0) {
      setAfilter({ ...Afilter, leagueUpper: 3000, leagueLower: 1400 });
    } else if (event.target.value == 2050) {
      setAfilter({ ...Afilter, leagueUpper: 3000, leagueLower: 2000 });
    } else if (event.target.value == 1900) {
      setAfilter({ ...Afilter, leagueUpper: 1999, leagueLower: 1875 });
    } else if (event.target.value == 1750) {
      setAfilter({ ...Afilter, leagueUpper: 1874, leagueLower: 1750 });
    } else if (event.target.value == 1600) {
      setAfilter({ ...Afilter, leagueUpper: 1749, leagueLower: 1650 });
    } else if (event.target.value == 1500) {
      setAfilter({ ...Afilter, leagueUpper: 1649, leagueLower: 1400 });
    }
  };

  for (let number = 0; number < totalPages; number++) {
    let isItemActive;
    if (activeItem === number) isItemActive = "page-item active";
    else {
      isItemActive = "page-item";
    }

    const handlePaginationChange = () => {
      setActiveItem(number);
    };

    items.push(
      <li
        className={isItemActive}
        key={number}
        onClick={handlePaginationChange}>
        <a>{number}</a>
      </li>
    );
  }
  const setResults = () => {
    const m = blogs
      .filter(
        (item) =>
          item.elo > parseInt(Afilter.leagueLower) &&
          parseInt(Afilter.leagueUpper) > item.elo
      )
      .filter((item) => {
        if (Afilter.city === "") {
          return item;
        } else if (
          item.city
            .toLowerCase()
            .trim()
            .includes(Afilter.city.toLowerCase().trim())
        ) {
          return item;
        }
      })
      .filter((item) => {
        const k = item.name
          .toLowerCase()
          .trim()
          .concat(item.lastName.toLowerCase().trim());
        if (Afilter.name === "") {
          return item;
        } else if (k.includes(Afilter.name.toLowerCase().replace(/\s+/g, ""))) {
          return item;
        }
        return false;
      });
    setAllPlayers(m);
  };
  useEffect(() => {
    setResults();
  }, [Afilter]);

  return (
    <>
      <div id='rankings'>
        <div className='selectors'>
          <div className='match-filters'>
            <div className='filter'>
              <div className='select-wp'>
                <select onChange={(e) => handleLeague(e)}>
                  <option value='0'>Всички Състезатели</option>
                  <option value='2050'>Супер Лига</option>
                  <option value='1900'>А Лига</option>
                  <option value='1750'>Б Лига</option>
                  <option value='1600'>В1 Лига</option>
                  <option value='1500'>В2 Лига</option>
                </select>
              </div>
            </div>
          </div>

          <div className='match-filters'>
            <div className='filter'>
              <div className='select-wp'>
                <div className='autocomplete'>
                  <p className='clear-filter' style={{ display: "none" }}>
                    <span className='fa fa-trash-o'></span>
                  </p>
                  <input
                    type='text'
                    value={setAfilter.city}
                    onChange={handleCity}
                    placeholder='(Град)'
                    className='form-control input-sm '
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='selectors'>
          <div className='match-filters'>
            <div className='filter'>
              <div className='select-wp'>
                <div className='autocomplete'>
                  <p className='clear-filter' style={{ display: "none" }}>
                    <span className='fa fa-trash-o'></span>
                  </p>
                  <input
                    type='text'
                    onChange={handleName}
                    placeholder='(Име)'
                    className='form-control input-sm'
                  />
                  <div
                    className='autocomplete-suggestions'
                    style={{ display: "none" }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='rank-list'>
          {Loading && AllPlayers ? (
            <ul>
              {AllPlayers.slice(
                activeItem * resultsPerPage,
                activeItem * resultsPerPage + resultsPerPage
              ).map((r) => (
                <PlayerRow key={`${r.id}`} {...r} />
              ))}
            </ul>
          ) : (
            <div>
              <ReactLoading
                type={"spin"}
                className={"loading-home"}
                color={"orange"}
                height={50}
                width={50}
                name={"Loading..."}
              />
              <h5 className={"loading-text"}>Loading...</h5>
            </div>
          )}

          {Loading ? (
            <div className='paginator'>
              <div className='paginator__display'>
                <span>
                  От{" "}
                  {AllPlayers.length > resultsPerPage
                    ? resultsPerPage
                    : AllPlayers.length}{" "}
                  от общо {AllPlayers.length} състезатели.
                </span>
              </div>
              <nav className='nav-pagination'>
                <ul className='pagination'>{items}</ul>
              </nav>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};
